import * as React from 'react'
import {useContext, useEffect, useState} from 'react'
import AliceCarousel from 'react-alice-carousel'
import {useTranslation} from 'react-i18next'
import {api} from '../api/api'
import {AppContext} from '../app'
import CarouselOutline from '../components/carouselOutline'
import Headquarters from '../components/headquarters'
import Modal from '../components/modal'
import ModalStatus from '../components/statusModal'
import '../css/about.css'
import AppProps from '../util/appProps'
import {ACCENT_TEXT, ACCENT_TEXT_FW500, goToElementId, goToHash, tagger, setTitleFont} from '../util/util'

const contactImgList = [
    'https://static.persona.ly/images/about/carousel-1.webp',
    'https://static.persona.ly/images/about/carousel-2.webp',
    'https://static.persona.ly/images/about/carousel-3.webp'
]

const HiringIdToIconMap = new Map([
    ['5a01de057c4b310010d29c91', 'https://static.persona.ly/images/about/group-26.svg'],
    ['5a01de897c4b310010d29c93', 'https://static.persona.ly/images/about/group-56.svg'],
    ['5a97f90a3ff6d600186851fa', 'https://static.persona.ly/images/about/group-23.svg'],
    ['5a5f7b5926ba6d00110f7832', 'https://static.persona.ly/images/about/group-62.svg'],
    ['5a4361ec355bf000120abac0', 'https://static.persona.ly/images/about/group-63.svg'],
    ['5a4362d9355bf000120abac1', 'https://static.persona.ly/images/about/group-63.svg'],
    ['5a01de477c4b310010d29c92', 'https://static.persona.ly/images/about/group-54.svg'],
    ['5a3a2e788f07940011ee8b7e', 'https://static.persona.ly/images/about/group-55.svg'],
    ['5a01dec27c4b310010d29c94', 'https://static.persona.ly/images/about/group-49.svg']
])

const About = (props: AppProps) => {

    const {t, i18n} = useTranslation('about')
    const tC = useTranslation('common').t

    const appContext = useContext(AppContext)
    const {utmParameters} = useContext(AppContext)

    const customizeListBlocks = [
        {
            title: t('Innovation'),
            text: t('Is about daring'),
            img: 'https://static.persona.ly/images/about/group-60.svg'
        },
        {
            title: t('Longevity'),
            text: t('Is about longevity'),
            img: 'https://static.persona.ly/images/about/survey-time-icon.svg'
        },
        {
            title: t('Challenge'),
            text: t('Is about facing'),
            img: 'https://static.persona.ly/images/about/group-61.svg'
        }
    ]

    const statusModalData1 = {
        title: 'Application Sent',
        text: 'Your job application has been recorded. We will review it and reply as soon as possible.'
    }

    const statusModalData2 = {
        title: 'Message Sent',
        text: 'Your message has been recorded. We will reply as soon as possible.'
    }

    const [state, setState] = useState({
        formError: false,
        showModal: false,
        dataModal: {
            title: 'null',
            text: 'null',
            brief: ['null'],
            requirements: ['null']
        },
        hiringList: [] as any[]
    })

    const [form, setForm] = useState({
        placement: 'about',
        type: 'monetization',
        name: '',
        company: '',
        email: '',
        phone: '',
        message: '',
        utm: utmParameters || {}
    })
    const [eName, setEName] = useState<string[]>([])
    const [eCompany, setECompany] = useState<string[]>([])
    const [eEmail, setEEmail] = useState<string[]>([])
    const [eMessage, setEMessage] = useState<string[]>([])

    const [statusModal1, setStatusModal1] = useState(false)
    const [statusModal2, setStatusModal2] = useState(false)

    const updateErrors = (name, company, email, message) => {
        setEName(name)
        setECompany(company)
        setEEmail(email)
        setEMessage(message)
    }

    useEffect(() => {
        setTitleFont(i18n.language)

        api.hiring().then(response => setState({...state, hiringList: response.results ? response.results : []}))
        appContext.setAboutIsMounted(true)
        return () => appContext.setAboutIsMounted(false)
    }, [])

    useEffect(() => goToHash(props), [props.location.hash])

    const imageOnLoadFunc = () => {
        if (props.location.hash) {
            goToHash(props)
        }
    }

    const toggleCareerModal = () => setState({...state, showModal: !state.showModal})

    const toggleStatusModal1 = () => setStatusModal1(!statusModal1)
    const toggleStatusModal2 = () => setStatusModal2(!statusModal2)

    const scrollToHandler = () => {goToElementId('about-carousel', true)}

    const renderHiringList = () => state.hiringList.map(data =>
        <div key={data._id} className="job-element" onClick={() => setState({
            ...state,
            showModal: !state.showModal,
            dataModal: data
        })}>
            <img width="37" height="37" src={HiringIdToIconMap.has(data._id) ? HiringIdToIconMap.get(data._id) : 'https://static.persona.ly/images/about/group-63.svg'} />{data.title}
        </div>
    )

    const onFormRadioChange = (e) => setForm({...form, type: e.currentTarget.value})

    const sendFormData = () => {
        updateErrors([], [], [], [])
        if (form.name && form.company && form.email && form.message) {
            api.postContactFormData(JSON.stringify(form))
                .then(() => {
                    setForm({
                        ...form,
                        name: '',
                        company: '',
                        email: '',
                        phone: '',
                        message: ''
                    })
                    toggleStatusModal2();
                    (window as any).dataLayer.push({ 'event': 'form-completed', 'location': 'About' })
                })
                .catch(() => setState({...state, formError: true}))
        } else {
            updateErrors(
                form.name ? [] : [tC('required field')],
                form.company ? [] : [tC('required field')],
                form.email ? [] : [tC('required field')],
                form.message ? [] : [tC('required field')]
            )
        }
    }

    return (
        <div className="about">
            <Modal data={state.dataModal} show={state.showModal} action={toggleStatusModal1} toggle={toggleCareerModal} />
            <ModalStatus data={statusModalData1} show={statusModal1} toggle={toggleStatusModal1} />
            <ModalStatus data={statusModalData2} show={statusModal2} toggle={toggleStatusModal2} />
            <div className="top-block">
                <div className="top-text-block text-center">
                    <div className="header-text ht-large muli"><span
                        className="accent-text">{t('We Lead')}</span> {t('We dont Follow')}</div>
                    <div className="medium-text mt-40">{t('We believe leadership')}</div>
                </div>
                <div className="scroll" onClick={scrollToHandler}>
                    <img src="https://static.persona.ly/images/path-2-copy-2.svg" />
                </div>
            </div>
            <div id="about-carousel" style={{paddingTop: '6rem'}}>
                <CarouselOutline blocks={customizeListBlocks} titleClass="medium-text about-car-m fw700" textClass="small-text mt-20" />
            </div>
            <div id="ad-tech-company" className="column-block cb-personaly text-center">
                <div className="header-text ht-medium muli">{tagger(t('Is a global mobile ad-tech'), ACCENT_TEXT)}</div>
                <div style={{maxWidth: 672}}>
                    <div className="small-text mt-30">{tagger(t('We create mobile monetization'), ACCENT_TEXT_FW500)}</div>
                </div>
            </div>
            <div className="we-work-block rb-1">
                <div className="img-block-1">
                    <img className="img-1" src="https://static.persona.ly/images/about/about-1.webp" />
                    <img className="img-2" src="https://static.persona.ly/images/about/about-2.webp" />
                    <img className="img-3" src="https://static.persona.ly/images/about/about-3.webp" />
                </div>
                <div className="column-block cb-55 we-work-smarter">
                    <div className="header-text ht-medium muli">{tagger(t('We Work'), ACCENT_TEXT)}</div>
                    <div className="medium-text mt-25 fw700">{t('We hold d')}</div>
                    <div className="small-text mt-20">
                        {tagger(t('Our founders focused on building'), ACCENT_TEXT_FW500)}
                        <br /><br />
                        {tagger(t('Our systems are constantly evolving'), ACCENT_TEXT_FW500)}
                    </div>
                </div>
            </div>
            <div className="we-work-block-2 cb-55">
                <div className="column-block we-work-block-2-column">
                    <div className="small-text mt-30">
                        {t('When faced with a new challenge')}
                        <br /><br />
                        {tagger(t('Whats optimal today'), ACCENT_TEXT_FW500)}
                    </div>
                    <img alt="" src="https://static.persona.ly/images/about/image-block-22.svg" style={{alignSelf: 'flex-end'}} />
                </div>
                <div className="img-block-2">
                    <div className="sub-block-2">
                        <img className="img-1" src="https://static.persona.ly/images/about/about-4.webp" />
                    </div>
                </div>
            </div>
            <div className="we-provide-block rb-3">
                <div className="img-block-3">
                    <div className="not-mobile" style={{marginRight: '1rem'}}>
                        <img className="img-1" src="https://static.persona.ly/images/about/about-5.webp" />
                        <img className="img-3" src="https://static.persona.ly/images/about/about-6.webp" />
                    </div>
                    <img className="img-2" src="https://static.persona.ly/images/about/about-7.webp" />
                </div>
                <div className="column-block cb-55">
                    <div className="header-text ht-medium muli">{tagger(t('We Provide'), ACCENT_TEXT)}</div>
                    <div className="medium-text mt-25 fw700">{t('We approach every')}</div>
                    <div className="small-text mt-20">
                        {t('Our partners success')}
                        <br /><br />
                        {tagger(t('We learn to know'), ACCENT_TEXT_FW500)}
                    </div>
                </div>
            </div>
            <div className="we-provide-block-2 rb-4">
                <div className="column-block cb-50 as-a-company">
                    <div className="small-text">
                        {tagger(t('As a company, we believe in'), ACCENT_TEXT_FW500)}
                        <br /><br />
                        {tagger(t('These ideals are embedded'), ACCENT_TEXT_FW500)}
                    </div>
                </div>
                <div className="img-block-4">
                    <div className="sub-block-4">
                        <img className="img-1" src="https://static.persona.ly/images/about/about-8.webp" />
                    </div>
                </div>
            </div>
            <div id="careers" className="we-provide-block-2 rb-4-c">
                <div className="column-block cb-50">
                    <div className="header-text ht-medium muli">{tagger(t('Join Our Team'), ACCENT_TEXT)}</div>
                    <div className="small-text mt-20">
                        {tagger(t('We strive to maintain a work'), ACCENT_TEXT_FW500)}
                        <br /><br />
                        {t('Always looking for passionate')}
                        <br /><br />
                        <span className="accent-text fw500">{t('Applicant discretion is guaranteed')}</span>
                    </div>
                </div>
                <div className="img-block-5 not-tablet not-mobile">
                    <div className="sub-block-5">
                        <img className="img-1" src="https://static.persona.ly/images/about/team.webp" />
                    </div>
                </div>
            </div>
            <div className="looking-for-block mt-60">
                <div className="column-block cb-60">
                    <div className="medium-text fw700">{t('Looking For')}</div>
                    <div className="jobs-block mt-40">
                        {renderHiringList()}
                    </div>
                </div>
                <div className="column-block cb-40">
                    <div className="medium-text not-tablet not-mobile fw700">{t('Our Values')}</div>
                    <div className="values-block mt-40">
                        <div className="values-elem">
                            <img width="83" height="88" src="https://static.persona.ly/images/about/04.svg" />{t('Encouraging Personal')}
                        </div>
                        <div className="values-elem">
                            <img width="83" height="88" src="https://static.persona.ly/images/about/05.svg" />{t('A Dynamic Company')}
                        </div>
                        <div className="values-elem">
                            <img width="83" height="88" src="https://static.persona.ly/images/about/06.svg" />{t('Positive Atmosphere')}
                        </div>
                    </div>
                </div>
            </div>
            <div id="contact" className="contact-block">
                <div className="column-block cb-50">
                    <div className="header-text ht-medium muli">{tagger(t('Wed Love to'), ACCENT_TEXT)}</div>
                    <div className="small-text mt-25">{t('What can we help you with')}</div>
                    <div className="contact-radio-block">
                        <label htmlFor="1" className="contact-radio-label">
                            <input id="1" className="contact-radio" type="radio" name="contactType"
                                value="monetization" checked={form.type == 'monetization'}
                                onChange={onFormRadioChange} />
                            {t('Monetization')}
                        </label>
                        <label htmlFor="2" className="contact-radio-label">
                            <input id="2" className="contact-radio" type="radio" name="contactType"
                                value="acquisition" checked={form.type == 'acquisition'}
                                onChange={onFormRadioChange} />
                            {t('User Acquisition')}
                        </label>
                        <label htmlFor="3" className="contact-radio-label">
                            <input id="3" className="contact-radio" type="radio" name="contactType"
                                value="research" checked={form.type == 'research'}
                                onChange={onFormRadioChange} />
                            {t('Market Research')}
                        </label>
                    </div>
                    <div className="column-block">
                        <div className="contact-input-row-block">
                            <div className="contact-input-container">
                                <input className={'contact-input small-text' + (eName.length > 0 ? ' error-input' : '')} type="text"
                                    name="contactName" placeholder="&nbsp;" value={form.name}
                                    onChange={e => setForm({...form, name: e.currentTarget.value})} />
                                <span className="contact-input-label">{t('Full name')}</span>
                                {eName && eName.map(err => <div className="error-small" key={err}>{err}</div>)}
                            </div>
                            <div className="contact-input-container">
                                <input className={'contact-input small-text' + (eCompany.length > 0 ? ' error-input' : '')} type="text"
                                    name="contactCompany" placeholder="&nbsp;" value={form.company}
                                    onChange={e => setForm({...form, company: e.currentTarget.value})} />
                                <span className="contact-input-label">{t('Company name')}</span>
                                {eCompany && eCompany.map(err => <div className="error-small" key={err}>{err}</div>)}
                            </div>
                        </div>
                        <div className="contact-input-row-block">
                            <div className="contact-input-container">
                                <input className={'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : '')} type="email"
                                    name="contactEmail" placeholder="&nbsp;" value={form.email}
                                    onChange={e => setForm({...form, email: e.currentTarget.value})} />
                                <span className="contact-input-label">{t('Email address')}</span>
                                {eEmail && eEmail.map(err => <div className="error-small" key={err}>{err}</div>)}
                            </div>
                            <div className="contact-input-container">
                                <input className="contact-input small-text" type="tel"
                                    name="contactPhone" placeholder="&nbsp;" value={form.phone}
                                    onChange={e => setForm({...form, phone: e.currentTarget.value})} />
                                <span className="contact-input-label">{t('Phone number')}</span>
                            </div>
                        </div>
                        <div className="row-block">
                            <div className="contact-input-area-container">
                                <textarea className={'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : '')}
                                    name="contactMessage" placeholder="&nbsp;" value={form.message}
                                    onChange={e => setForm({...form, message: e.currentTarget.value})} />
                                <span className="contact-input-label">{t('Message')}</span>
                                {eMessage && eMessage.map(err => <div className="error-small" key={err}>{err}</div>)}
                            </div>
                        </div>
                    </div>
                    <button className="contact-button mt-50" type="submit" onClick={sendFormData}>
                        {tC('Send')}
                    </button>
                </div>
                <div className="column-block pictures images-rounded">
                    <AliceCarousel
                        autoHeight={false}
                        buttonsDisabled={true}
                        infinite={false}
                        mouseTrackingEnabled={true}
                        items={contactImgList.map((img, i) =>
                            <img onDragStart={(e) => e.preventDefault()} key={i} src={img} />)} />
                </div>
            </div>
            <Headquarters showButton={false} />
            <img width="0" height="0" src="https://static.persona.ly/images/on-load-pixel.gif" onLoad={imageOnLoadFunc}/>
        </div>
    )
}

export default About


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/about.tsx